import { Club } from "../../types/club/Club";
import { ClubSearchInput } from "../../types/club/ClubSearchInput";
import { SportAssociationNumberOf } from "../../types/SportAssociation";

type MultiClubResponse = {
  clubs: Club[];
  nextPage: number;
};

export const fetchClubs = async (
  backendUrl: string,
  sportAssociation: string,
  body: ClubSearchInput,
): Promise<MultiClubResponse> => {
  console.log();
  const response = await fetch(backendUrl + "/club/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Sport-Association": SportAssociationNumberOf(sportAssociation),
    },
    body: JSON.stringify(body),
  });
  const data = await response.json();
  return data;
};
